import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import MenuCategories from "@/components/MenuCategories";
import MenuBrowser from "@/components/MenuBrowser";
import Features from "@/components/Features";
import Catering from "@/components/Catering";
import CateringPackages from "@/components/CateringPackages";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import OrderSection from "@/components/OrderSection";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingCTAs from "@/components/FloatingCTAs";
import Admin from "@/pages/Admin";
import Order from "@/pages/Order";
import OrderSuccess from "@/pages/OrderSuccess";

const Home = () => (
  <main className="grain">
    <Navbar />
    <Hero />
    <Marquee />
    <About />
    <MenuCategories />
    <MenuBrowser />
    <Features />
    <CateringPackages />
    <Catering />
    <Gallery />
    <Reviews />
    <OrderSection />
    <Contact />
    <Footer />
    <FloatingCTAs />
  </main>
);

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, anchors: true }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/order" element={<Order />} />
          <Route path="/order/success" element={<OrderSuccess />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </ReactLenis>
  );
}

export default App;
